import {gql} from "@apollo/client";

export const GetMoms = gql`
  query GetMoms(
    $token: String!
    $after: Cursor
    $startDate: Time
    $endDate: Time
    $customerID: ID!
    $first: Int
    $orderBy: AtsMomMasterOrder
  ) {
    GetMoms(
      token: $token
      after: $after
      customerID: $customerID
      startDate: $startDate
      endDate: $endDate
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          meetingNo
          meetingDate
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const getMomByNodeId = gql`
  query GetJunctionNode($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on AtsMomMaster {
        meetingDate
      }
    }
  }
`;

export const GetMomDetails = gql`
  query GetMomDetails(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $latest: Boolean!
  ) {
    GetMomDetails(
      token: $token
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      latest: $latest
    ) {
      id
      pmuComments
      vendorResponse
      pmuDocuments
      vendorDocuments
      pmuResponse
      pmuResponseDocuments
      customerID
      momID
      projectID
      momMasterDetails {
        meetingDate
      }
      projectDetails {
        supplierName {
          desc
        }
      }
    }
  }
`;

export const getMomDetailsByNodeId = gql`
  query getMomDetailsByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      ... on AtsMomDetails {
        id
        pmuComments
        vendorResponse
        vendorNotes
        vendorNotesDocuments
        pmuDocuments
        vendorDocuments
        pmuResponse
        pmuResponseDocuments
        actionTaken
      }
    }
  }
`;
export const GetMomAttCount = gql`
  query GetMomAttCount(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $latest: Boolean!
  ) {
    GetMomAttCount(
      token: $token
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      latest: $latest
    ) {
      empCount
      inviteesCount
    }
  }
`;

export const GetMomAtt = gql`
  query GetMomAtt(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $latest: Boolean!
  ) {
    GetMomAtt(
      token: $token
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      latest: $latest
    ) {
      empDetails {
        id
        name
        empType
      }
    }
  }
`;

export const GetVendorNotes = gql`
  query GetVendorNotes(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $latest: Boolean!
  ) {
    GetVendorNotes(
      token: $token
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      latest: $latest
    ) {
      id
      vendorNotes
      vendorNotesDocuments
    }
  }
`;

export const GetMomInvitees = gql`
  query GetMomInvitees(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $projectID: ID!
    $latest: Boolean!
  ) {
    GetMomInvitees(
      token: $token
      customerID: $customerID
      momID: $momID
      projectID: $projectID
      latest: $latest
    )
  }
`;

export const GetMomsForProject = gql`
  query GetMomsForProject(
    $token: String!
    $customerID: ID!
    $projectID: ID!
    $empID: ID!
  ) {
    GetMomsForProject(
      token: $token
      customerID: $customerID
      projectID: $projectID
      empID: $empID
    ) {
      momID
      meetingDate
      pmuCount
      vendorRespCount
      attCount
    }
  }
`;

export const GetMomNode = gql`
  query GetMomNode(
    $token: String!
    $customerID: ID!
    $momID: ID!
    $latest: Boolean!
  ) {
    GetMomNode(
      token: $token
      customerID: $customerID
      momID: $momID
      latest: $latest
    ) {
      id
      meetingNo
      meetingDate
    }
  }
`;
